import React, { memo } from 'react';

const IndustryTableComponent = ({ industry, records, sortConfigs, sortData }) => {
  const industryCount = records[industry].length;

  return (
    <div key={industry} className="table_technology_wrapper mt-4">
      <div className="head_top">
        <h5 className="main_head">
          {industry} ({industryCount})
        </h5>
      </div>
      <div className="table_block">
        <div className="table-responsive table-container">
          <table className="table table-striped table-bordered new_comp_table">
            <thead>
              <tr className="new_comp_tr1">
                <th
                  scope="col"
                  className="new_comp_th"
                  onClick={() => sortData(industry, "supplier_name")}
                >
                  Supplier Name
                  {sortConfigs[industry]?.column === "supplier_name" ? (
                    sortConfigs[industry].direction === "asc" ? (
                      <span className="sort-icon">▲</span>
                    ) : (
                      <span className="sort-icon">▼</span>
                    )
                  ) : (
                    <span className="sort-dicon">▲</span>
                  )}
                </th>
                <th
                  scope="col"
                  className="new_comp_th"
                  onClick={() => sortData(industry, "geography")}
                >
                  Geography
                  {sortConfigs[industry]?.column === "geography" ? (
                    sortConfigs[industry].direction === "asc" ? (
                      <span className="sort-icon">▲</span>
                    ) : (
                      <span className="sort-icon">▼</span>
                    )
                  ) : (
                    <span className="sort-dicon">▲</span>
                  )}
                </th>
                <th
                  scope="col"
                  className="new_comp_th"
                  onClick={() => sortData(industry, "source")}
                >
                  Source
                  {sortConfigs[industry]?.column === "source" ? (
                    sortConfigs[industry].direction === "asc" ? (
                      <span className="sort-icon">▲</span>
                    ) : (
                      <span className="sort-icon">▼</span>
                    )
                  ) : (
                    <span className="sort-dicon"> ▲</span>
                  )}
                </th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(records[industry]) &&
                records[industry].map((item, index) => (
                  <tr key={index} className="new_comp_tr">
                    <td className="new_comp_td">{item.supplier_name}</td>
                    <td className="new_comp_td">{item.geography}</td>
                    <td className="new_comp_td">{item.source}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default memo(IndustryTableComponent);